import * as React from "react";

import { Button } from "semantic-ui-react";

import { ActionableTaskButtonProps } from "./ActionableTaskButtons";

import { Link } from "redux-little-router";

const ManagerViewPhysiotherapyReferralReportButton: React.FunctionComponent<ActionableTaskButtonProps> = (props) => {
    return (
        <Link href={`/actions/${props.task.caseId}/view-physiotherapy-report/${props.task.id}`}>
            <Button
                secondary
                content="View"
            />
        </Link>
    );
};

export { ManagerViewPhysiotherapyReferralReportButton };
